import { Injectable, Inject } from 'ng-metadata/core';

import { BugsnagService } from 'services/bugsnag.service';
import { EtomsService } from 'services/etoms.service';

@Injectable()
export class ApiService {
  public url: string = process.env.MIX_API;

  constructor(
    @Inject('$q') protected $q: ng.IQService,
    @Inject('$log') protected $log: ng.ILogService,
    @Inject('$http') protected $http: ng.IHttpService,
    @Inject('$sessionStorage') protected $sessionStorage,
    @Inject(BugsnagService) protected bugsnagService: BugsnagService,
    @Inject(EtomsService) protected etomsService: EtomsService,
  ) {
    // Use Angular's Q object as Promise.
    // This is needed to make async/await work properly with the UI.
    // See http://stackoverflow.com/a/41825004/536
    window['Promise'] = this.$q;
  }

  getRequest(resourcePath: string, data?: {}) {
    const config = {
      method: 'GET',
      url: `${this.url}${resourcePath}`,
      params: data,
      withCredentials: true,
    };

    return this.$http(config)
      .then(this.handleSuccess.bind(this))
      .catch(this.handleError.bind(this))
    ;
  }

  postRequest(resourcePath: string, data?: {}) {
    const config = {
      data,
      method: 'POST',
      url: `${this.url}${resourcePath}`,
      withCredentials: true,
    };

    return this.$http(config)
      .then(this.handleSuccess.bind(this))
      .catch(this.handleError.bind(this))
    ;
  }

  handleSuccess(response) {
    if (response && response.hasOwnProperty('data')) {
      return response.data;
    }

    return response;
  }

  handleError(response) {
    if (response.status === 401) {
      this.$log.error('User not logged in');
    }

    if (response && response.hasOwnProperty('data')) {
      return this.$q.reject(response.data);
    }

    return this.$q.reject(response);
  }

}



// WEBPACK FOOTER //
// ./resources/assets/js/services/api.service.ts